export default "__VITE_ASSET__036ff4d8__"